var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container", class: { experiment: _vm.isExperiment } },
    [
      _vm.isExperiment
        ? _c("div", { staticClass: "apps" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "divider" }),
            _vm._v(" "),
            _vm._m(1)
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "join-cta", class: { mobile: _vm.isMobile(_vm.$mq) } },
        [
          _c("h3", [
            _vm._v("Join over 10 million people learning on Brilliant")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "btn-container" }, [
            _c(
              "a",
              {
                directives: [
                  {
                    name: "track",
                    rawName: "v-track:click",
                    value: {
                      axId: _vm.btnAxId,
                      axType: "button"
                    },
                    expression:
                      "{\n          axId: btnAxId,\n          axType: 'button',\n        }",
                    arg: "click"
                  }
                ],
                staticClass: "btn signup-btn",
                attrs: { href: _vm.buttonHref },
                on: { click: _vm.handleButtonClick }
              },
              [_vm._v("\n        " + _vm._s(_vm.buttonText) + "\n      ")]
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "app-store apple-store" }, [
      _c(
        "a",
        {
          staticClass: "app-link",
          attrs: {
            href:
              "https://apps.apple.com/us/app/brilliant-learn-interactively/id913335252"
          }
        },
        [
          _c("img", {
            attrs: {
              src: "/site_media/version-a06e30ad0c/images/homepage/appstore.png"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "rating" }, [
        _c("span", { staticClass: "b-sprite-paywall-pix-stars-big stars" }),
        _vm._v(" "),
        _c("p", [_vm._v("10k+ Ratings")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "app-store play-store" }, [
      _c(
        "a",
        {
          staticClass: "app-link",
          attrs: {
            href:
              "https://play.google.com/store/apps/details?id=org.brilliant.android"
          }
        },
        [
          _c("img", {
            attrs: {
              src:
                "/site_media/version-ff92b52944/images/homepage/playstore.png"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "rating" }, [
        _c("span", { staticClass: "b-sprite-paywall-pix-stars-big stars" }),
        _vm._v(" "),
        _c("p", [_vm._v("60k+ Ratings")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }